// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"upperSection_wrapper__1dg9X"};